import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var ANNOUNCEMENTS_QUERY_KEY = 'announcements';
var announcementKeys = {
  announcements: [ANNOUNCEMENTS_QUERY_KEY],
  singleAnnouncement: function singleAnnouncement(announcementId) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$includeUnformatt = _ref.includeUnformattedMessage,
      includeUnformattedMessage = _ref$includeUnformatt === void 0 ? false : _ref$includeUnformatt;
    return [ANNOUNCEMENTS_QUERY_KEY, announcementId, includeUnformattedMessage];
  },
  announcementsList: function announcementsList(_ref2) {
    var page = _ref2.page,
      limit = _ref2.limit,
      _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? '' : _ref2$search,
      includeDraftsAndScheduled = _ref2.includeDraftsAndScheduled,
      includeTotal = _ref2.includeTotal;
    return [ANNOUNCEMENTS_QUERY_KEY, 'list', limit, page, search, includeDraftsAndScheduled, includeTotal];
  }
};
export default announcementKeys;